import { Alert, Snackbar } from '@mui/material';
import React from 'react';

export default function SnakeBarComponent({ isGood, message, open, handleClose }) {
  return (
    <div>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{ minWidth: '600px' }}
      >
        {isGood ? (
          <Alert onClose={handleClose} severity="success" variant="filled" sx={{ width: '100%' }}>
            {message}
          </Alert>
        ) : (
          <Alert onClose={handleClose} severity="error" variant="filled" sx={{ width: '100%' }}>
            {message}
          </Alert>
        )}
      </Snackbar>
    </div>
  );
}
